import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=e81f3a72&scoped=true&"
import script from "./Song.vue?vue&type=script&lang=js&"
export * from "./Song.vue?vue&type=script&lang=js&"
import style0 from "./Song.vue?vue&type=style&index=0&id=e81f3a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81f3a72",
  null
  
)

export default component.exports